import { Box, Typography } from '@mui/material';
import React from 'react';
import moment from 'moment';
import CustomTooltip from '../../utils/CustomTooltip';
import { globalClasses } from '../../utils/globalUtils';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';

const DocumentNameRow = (params) => {
  const fileName = params?.value;
  if (params?.value !== undefined) {
    return (
      <CustomTooltip title={fileName}>
        <Typography
          variant="body1"
          fontWeight="400"
          className={`${globalClasses.agGridCellCustomTypo} ${classes.documentRowTypographyColor}`}
        >
          {fileName}
        </Typography>
      </CustomTooltip>
    );
  }
};

const scanHistoryDate = (params) => {
  const { value } = params;
  const formattedDate = moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss');

  return (
    <Box>
      {value !== undefined && value !== null ? (
        <Typography variant="body1" fontWeight="400">
          {formattedDate}
        </Typography>
      ) : (
        <Typography>-</Typography>
      )}
    </Box>
  );
};

const ResponsiveFontsize = (params) => {
  if (params?.data) {
    if (params?.value !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.value}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const DocumentTypeRenderer = (params) => {
  if (params?.data) {
    if (params?.value !== undefined) {
      const getDocumentTypeLabel = () => {
        switch (params?.value) {
          case 'BS':
            return 'Bank Statement';
          case 'CC':
            return 'Credit Card Statement';
          case 'sales':
            return 'Sales';
          case 'invoice':
            return 'Direct Expenses';
          case 'receipt':
            return 'Indirect Expenses';
          default:
            break;
        }
      };
      return (
        <Typography variant="body1" fontWeight={400}>
          {getDocumentTypeLabel()}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

// const AccuracyRow = (params) => {
//   const status = params?.data?.status;
//   if (params?.data && status === 'Completed') {
//     const formattedAccuracy = params?.data?.accuracy
//       ? parseFloat(params?.data?.accuracy).toFixed(2)
//       : '-';
//     return (
//       <CustomTooltip title={formattedAccuracy}>
//         <Typography
//           variant="body1"
//           color={lightPalette.lunarBase.main}
//           fontWeight="400"
//           className={classes.documentRowTypography}
//         >
//           {formattedAccuracy}
//         </Typography>
//       </CustomTooltip>
//     );
//   }
//   return <Typography>-</Typography>;
// };

const ImportTypeRow = (params) => {
  const importType =
    params?.data?.documentSummary.length &&
    params?.data?.documentSummary[0].import_type;
  if (params?.data && importType) {
    return (
      <CustomTooltip title={importType}>
        <Typography
          variant="body1"
          color={lightPalette.lunarBase.main}
          fontWeight="400"
          className={classes.documentRowTypography}
        >
          {importType}
        </Typography>
      </CustomTooltip>
    );
  }
  return <Typography>-</Typography>;
};

const ImportOptionRow = (params) => {
  const importOption =
    params?.data?.documentSummary.length &&
    params?.data?.documentSummary[0].import_option;
  if (params?.data && importOption) {
    return (
      <CustomTooltip title={importOption}>
        <Typography
          variant="body1"
          color={lightPalette.lunarBase.main}
          fontWeight="400"
          className={classes.documentRowTypography}
        >
          {importOption}
        </Typography>
      </CustomTooltip>
    );
  }
  return <Typography>-</Typography>;
};
const ImportCredentialRow = (params) => {
  const importCredential =
    params?.data?.documentSummary.length &&
    params?.data?.documentSummary[0].import_credential;
  if (params?.data && importCredential) {
    return (
      <CustomTooltip title={importCredential}>
        <Typography
          variant="body1"
          color={lightPalette.lunarBase.main}
          fontWeight="400"
          className={classes.documentRowTypography}
        >
          {importCredential}
        </Typography>
      </CustomTooltip>
    );
  }
  return <Typography>-</Typography>;
};

const ScanHistoryColumnDef = (
  gridSettingData,
  gridKey,
  // setCustomFilterValue,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    {
      headerName: 'Document Name',
      field: 'name',
      minWidth: isSmallScreen ? 200 : 300,
      maxWidth: isSmallScreen ? 250 : 400,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      cellRenderer: DocumentNameRow,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
      hide: false,
    },
    {
      headerName: 'Document Type',
      field: 'document_type',
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 180 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      type: 'checkBox',
      filterParams: {
        customFilterValue,
        gridKey,
      },
      cellRenderer: DocumentTypeRenderer,
    },
    {
      headerName: 'Uploaded At',
      field: 'created_at',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      minWidth: isSmallScreen ? 250 : 330,
      maxWidth: isSmallScreen ? 270 : 350,
      sortable: true,
      cellRenderer: scanHistoryDate,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true,
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: isSmallScreen ? 250 : 320,
      maxWidth: isSmallScreen ? 270 : 330,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      type: 'checkBox',
      filterParams: {
        customFilterValue,
        gridKey,
      },
      cellRenderer: ResponsiveFontsize,
    },
    {
      headerName: 'Import Type',
      field: 'importType',
      maxWidth: isSmallScreen ? 250 : 320,
      minWidth: isSmallScreen ? 260 : 330,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: ImportTypeRow,
    },
    {
      headerName: 'Import Option',
      field: 'importOption',
      minWidth: isSmallScreen ? 250 : 320,
      maxWidth: isSmallScreen ? 270 : 330,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: ImportOptionRow,
    },
    {
      headerName: 'Import Credential',
      field: 'importCredential',
      minWidth: isSmallScreen ? 250 : 320,
      maxWidth: isSmallScreen ? 270 : 330,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: ImportCredentialRow,
    },
    {
      headerName: ' ',
      field: ' ',
      resizable: false,
      minWidth: isSmallScreen ? 150 : 200,
    },
  ];
};

export default ScanHistoryColumnDef;
